import * as Sentry from '@sentry/browser'
import { z } from 'zod'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'

// This is duplicated at Mastra
const AiReportsCreationCopilotResultSchema = z.object({
  type: z.enum(['text2sql', 'textAnswer']),
  textAnswer: z.optional(z.string()),
  sqlAnswer: z.object({
    title: z.string().describe('the title of the SQL'),
    sql: z.string().describe('the SQL query generated by the agent'),
    summary: z.string().describe('a summary of the SQL'),
    description: z.string().describe('a description of the SQL'),
    tables: z.array(z.string()).describe('the tables used in the SQL'),
    query_summary: z.string().describe('a summary of the query'),
    success: z.boolean().describe('whether the SQL was generated successfully'),
    synthetic_sql: z
      .boolean()
      .describe(
        'whether the SQL was generated synthetically from context information related to similar queries'
      ),
    resolved_entities_info: z
      .array(z.string())
      .describe(
        'a description of the resolved entities used in the generated query. If you have applied any filter related a resolved entity, include the entity information here.'
      ),
    column_format_hints: z
      .array(
        z.object({
          column_alias: z.string().describe('the alias of the column'),
          column_format: z.string().describe('the format of the column'),
        })
      )
      .describe('an array of objects with the alias and format of the columns used in the SQL'),
  }),
  currentDataset: z.optional(z.string()),
  filters: z.optional(
    z.object({
      snapshotDate: z.optional(z.date()),
      dateRange: z.optional(
        z.object({
          from: z.date(),
          to: z.date(),
        })
      ),
    })
  ),
})

export type AiReportsResult = z.infer<typeof AiReportsCreationCopilotResultSchema>

const useCreateAnalyticsReportActionResolver: OneCreationActionResolver = () => {
  const { navigation } = useNavigation()
  return {
    resolver: async (args: AiReportsResult) => {
      try {
        return {
          to: navigation.aiReports.fullPath(),
          data: args,
        }
      } catch (error) {
        Sentry.captureException(error)
        return
      }
    },
    loading: false,
  }
}

export const AiReportsAction: OneCreateAction = {
  actionResolver: useCreateAnalyticsReportActionResolver,
  policies: ['Iris_aiAnalyticsSeeAiAnalytics'],
  module: 'ai_reports',
}
